import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-timer/jb-timer.css.ts
var jb_timer_css_default = i`div{font-family:var(--theme-font-bold-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-weight:var(--theme-font-bold-weight, 700)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}div{color:color-mix(in srgb, currentcolor calc(var(--theme-opacity-80, 0.8) * 100%), transparent);font-size:.813rem}@supports(color: rgb(from currentcolor r g b/1)){div{color:rgb(from currentcolor r g b/var(--theme-opacity-80, 0.8))}}div.right-aligned{text-align:right}`;

export {
  jb_timer_css_default
};
